import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { getUserManager } from "../../auth";
import { Loader } from "../navigation";

interface SignInHandlerProps extends RouteComponentProps<any> {
  onSignInError: (error: Error) => void;
}

export const SignInHandlerComponent = class extends React.Component<SignInHandlerProps> {
  public async componentDidMount() {
    const { onSignInError, location } = this.props;

    try {
      const locationState = location.state as { from?: { pathname: string } };
      // Upon signing in redirect to the route we originally navigated from within the ProtectedRoute, or if the
      // from location is missing, fallback to the index page "/"
      await getUserManager().signinRedirect({ data: { path: locationState ? locationState.from : "/" } });
    } catch (error) {
      onSignInError(error);
    }
  }

  public render() {
    return <Loader loadingText={"Signing-in"} />;
  }
};

export const SignInHandler = SignInHandlerComponent;
